// extracted by mini-css-extract-plugin
export default {"activeLink":"menuWide-module--activeLink--xWKOM","menuWide":"menuWide-module--menuWide--b+3VP","container":"menuWide-module--container--vYlhq"};